import colors from "./colors"
import * as constants from "./constants"

const root = {
  name: "Default",
  version: "0.0.1",
}

export const DefaultTheme = {
  ...root,
  constants,
  colors,
}
